import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IUserAuthenticationTokens } from "../types";

export interface IUserRegistrationMutationParameters {
    uuid: string;
    token: string;
    password?: string;
    name?: string;
    surname?: string;
}

export type IUserRegistrationMutationResult = IUserAuthenticationTokens;

export const registrationMutation: IApiMutationFunction<IUserRegistrationMutationParameters> = ({
    uuid,
    token,
    password,
    name,
    surname,
}) => {
    return {
        method: "PUT",
        url: `/users/${uuid}/registration`,
        data: {
            token,
            password,
            name,
            surname,
        },
    };
};

export const useUserRegistrationMutation = createApiMutationHook<
    IUserRegistrationMutationParameters,
    IUserRegistrationMutationResult
>(registrationMutation);
